import Length from '../../../../source/js/shared/models/Geometry/Length';
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { MinimumValue } from "@/Models/Validators/MinimumValue";
import { MaximumValue } from "@/Models/Validators/MaximumValue";
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import { ShapeCategory } from '@/types/shapeCategories';

export default class StarConfiguration implements ShapeConfigurationInterface {
	get_dimension_keys(): string[] {
		return [
			'inner_radius',
			'outer_radius',
		];
	}

	get_modifier_keys(): string[] {
		return [
			'number_of_points',
		];
	}

	get_maximum_dimensions( maximum_rectangle ): Record<string, Length|number> {
		const maximum_radius = maximum_rectangle.get_shortest_side().divide( 2 );

		return {
			inner_radius:maximum_radius,
			outer_radius:maximum_radius,
			number_of_points: 15,
		};
	}

	get_labels(): Record<string, string> {
		const { inner_radius, outer_radius, number_of_points } = window.measurementSelectorVariables.i18n.dimensionNames;

		return {
			inner_radius,
			outer_radius,
			number_of_points,
		};
	}

	get_validators(): Record<string, Array<unknown>> {
		return {
			inner_radius: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
			outer_radius: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
			number_of_points: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
		};
	}

	get_category(): ShapeCategory {
		return 'complex';
	}
}
